import DOMPurify from 'dompurify';

import { User } from './user';

export interface MessageData {
	createdAt: string;
	feedbackId: string;
	id: string;
	text: string;
	updatedAt: string;
	user: User;
	userId: string;
}

export class Message {
	createdAt: Date;
	feedbackId: string;
	id: string;
	text: string;
	updatedAt: Date;
	user: User;
	userId: string;

	constructor(data: MessageData) {
		this.createdAt = new Date(data.createdAt);
		this.feedbackId = data.feedbackId;
		this.id = data.id;
		this.text = data.text;
		this.updatedAt = new Date(data.updatedAt);
		this.user = data.user;
		this.userId = data.userId;
	}

	get plainText(): string {
		return DOMPurify.sanitize(this.text);
	}
}
